export default "__VITE_ASSET__CXhtIZSW__"